import { useStoreLogger } from '@/logger.ts'
import type {
  IAoeCustomer,
  IAoeRegistration,
  IAoeRegistrationResponse,
  ICustomerResponse
} from '@/types/CustomerTypes.ts'
import { CustomerGet, AccountCreate } from '@/api/Customer.ts'

export const CustomerLocalStorageKey = 'AoeCustomer'

export function GetCustomerFromLocalStorage(
  beeNumberCustomer: number
): IAoeCustomer | null {
  const logger = useStoreLogger()
  logger.debug('GetCustomerFromLocalStorage', beeNumberCustomer)
  const key = CustomerLocalStorageKey
  const json = localStorage.getItem(key)
  if (json) {
    logger.debug('Customer found in local storage')
    const cust: IAoeCustomer = JSON.parse(json)
    if (cust.beeNumber === beeNumberCustomer) {
      return cust
    }
  }
  logger.debug('Customer not found in local storage')
  return null
}

export async function GetCustomerFromLocalStorageOrApi(
  beeNumberCustomer: number
): Promise<IAoeCustomer | null> {
  const logger = useStoreLogger()
  logger.debug('GetCustomerFromLocalStorageOrApi', beeNumberCustomer)

  let cust = GetCustomerFromLocalStorage(beeNumberCustomer)
  if (cust) return cust

  const custResponse = await CustomerGet(beeNumberCustomer)
  if (custResponse) {
    SaveCustomerToLocalStorage(custResponse)
    cust = GetCustomerFromLocalStorage(beeNumberCustomer)
  }
  return cust
}

export function SaveCustomerToLocalStorage(customerResponse: ICustomerResponse) {
  const newValue = JSON.stringify(customerResponse.item)
  const logger = useStoreLogger()
  logger.debug('SaveCustomerToLocalStorage', newValue)
  const key = CustomerLocalStorageKey
  localStorage.setItem(key, newValue)
  window.dispatchEvent(
    new StorageEvent('storage', { key, newValue, storageArea: localStorage }),
  )
}

export async function CreateAccount(
  request: IAoeRegistration
): Promise<IAoeRegistrationResponse | null> {
  const logger = useStoreLogger()
  logger.debug('CreateAccount', request)

  const response = await AccountCreate(request)
  return response
}
